import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface UseCashBackDialogData {
  subscriptionId?: number;
  customerId?: number;
  availableCashBack?: number;
}

export interface UseCashBackResult {
  cashbackValue: number;
  cashbackNote: string;
}
@Component({
  selector: "fury-cashback",
  templateUrl: "./cashback.component.html",
  styleUrls: ["./cashback.component.scss"],
})
export class CashbackComponent {
  cashbackValue: number = 0;
  cashbackNote: string = "";

  constructor(
    private dialogRef: MatDialogRef<CashbackComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UseCashBackDialogData,
  ) {
    // Set default value if available cashback is passed
    if (data?.availableCashBack) {
      this.cashbackValue = data.availableCashBack;
    }
  }

  onSubmit(): void {
    if (!this.cashbackValue || this.cashbackValue <= 0) {
      console.warn("CashBack value must be greater than 0");
      return;
    }

    const result: UseCashBackResult = {
      cashbackValue: this.cashbackValue,
      cashbackNote: this.cashbackNote,
    };

    console.log("Use CashBack:", result);
    this.dialogRef.close(result);
  }

  onClose(): void {
    this.dialogRef.close(null);
  }
}
